module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("Sales Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "toDate"
    }
  }, [_vm._v("Store")]), _vm._v(" "), (!_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select store",
      "showClear": true
    },
    model: {
      value: (_vm.warehouseId),
      callback: function($$v) {
        _vm.warehouseId = $$v
      },
      expression: "warehouseId"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select store",
      "disabled": true
    },
    model: {
      value: (_vm.warehouseId),
      callback: function($$v) {
        _vm.warehouseId = $$v
      },
      expression: "warehouseId"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Search",
      "icon": "pi pi-search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchUnsettledSales.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-5"
  }, [(this.unSettleSalesChildHeaderLists.length > 0) ? _c('Button', {
    staticClass: "p-button-raised p-button-warning",
    attrs: {
      "icon": "pi pi-refresh",
      "label": "Reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), (this.unSettleSalesChildHeaderLists.length > 0) ? _c('a', {
    staticClass: "p-field p-col-12 p-md-12",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportCSV()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "float": "right",
      "height": "3em",
      "width": "3em"
    },
    attrs: {
      "src": require("../../../../static/img/excel.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.cashSales))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(1), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.esewaSales))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(2), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.fonepaySales))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(3), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.khaltiSales))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(4), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.darazSales))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(5), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.bankSales))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(6), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.cashUnpaidSales))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(7), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.esewaUnpaidSales))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(8), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.fonepayUnpaidSales))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(9), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.khaltiUnpaidSales))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(10), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.totalDarazUnpaid))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(11), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.bankUnpaidSales))])])]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('DataTable', {
    ref: "po",
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.unSettleSalesChildHeaderLists,
      "paginator": true,
      "editMode": "cell",
      "rows": 100,
      "filters": _vm.filters,
      "rowsPerPageOptions": [100, 500, 1000],
      "data-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "Miti",
      "sortable": true,
      "field": "salesDateNepali",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesDateNepali']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesDateNepali', $$v)
            },
            expression: "filters['salesDateNepali']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Date",
      "sortable": true,
      "field": "salesDate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesDate', $$v)
            },
            expression: "filters['salesDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Time",
      "sortable": true,
      "field": "time",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['time']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'time', $$v)
            },
            expression: "filters['time']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bill No",
      "sortable": true,
      "field": "billPrefix",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billPrefix']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billPrefix', $$v)
            },
            expression: "filters['billPrefix']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Customer",
      "sortable": true,
      "field": "customerName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['customerName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'customerName', $$v)
            },
            expression: "filters['customerName']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n            Total:\n          ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Contact",
      "sortable": true,
      "field": "contactNumber",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['contactNumber']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'contactNumber', $$v)
            },
            expression: "filters['contactNumber']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Address",
      "sortable": true,
      "field": "deliveryAddress",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['deliveryAddress']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'deliveryAddress', $$v)
            },
            expression: "filters['deliveryAddress']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Pay status",
      "bodyStyle": "text-align: right",
      "field": "paymentStatus",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['paymentStatus']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'paymentStatus', $$v)
            },
            expression: "filters['paymentStatus']"
          }
        })]
      },
      proxy: true
    }, {
      key: "editor",
      fn: function(slotProps) {
        return [_c('Dropdown', {
          attrs: {
            "options": _vm.statusesPay,
            "optionLabel": "label",
            "optionValue": "value",
            "placeholder": "Select a Status"
          },
          on: {
            "change": function($event) {
              return _vm.updatePaymentStatus(slotProps.data)
            }
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function(slotProps) {
              return [_c('span', [_vm._v(_vm._s(slotProps.option.label))])]
            }
          }], null, true),
          model: {
            value: (slotProps.data['paymentStatus']),
            callback: function($$v) {
              _vm.$set(slotProps.data, 'paymentStatus', $$v)
            },
            expression: "slotProps.data['paymentStatus']"
          }
        })]
      }
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n            " + _vm._s(_vm.getPayStatusLabel(slotProps.data.paymentStatus)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Pay Method",
      "bodyStyle": "text-align: right",
      "field": "paymentMethod",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['paymentMethod']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'paymentMethod', $$v)
            },
            expression: "filters['paymentMethod']"
          }
        })]
      },
      proxy: true
    }, {
      key: "editor",
      fn: function(slotProps) {
        return [_c('Dropdown', {
          attrs: {
            "options": _vm.payMethod,
            "optionLabel": "label",
            "optionValue": "value",
            "placeholder": "Select a Status"
          },
          on: {
            "change": function($event) {
              return _vm.updatePaymentStatus(slotProps.data)
            }
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function(slotProps) {
              return [_c('span', [_vm._v(_vm._s(slotProps.option.label))])]
            }
          }], null, true),
          model: {
            value: (slotProps.data['paymentMethod']),
            callback: function($$v) {
              _vm.$set(slotProps.data, 'paymentMethod', $$v)
            },
            expression: "slotProps.data['paymentMethod']"
          }
        })]
      }
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n            " + _vm._s(_vm.getPaymentMethodLabel(slotProps.data.paymentMethod)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Dis Amt",
      "bodyStyle": "text-align: right",
      "field": "discountAmount",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['discountAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'discountAmount', $$v)
            },
            expression: "filters['discountAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n            " + _vm._s(_vm.totalDiscountAmount.toFixed(2)) + "\n          ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Amount",
      "bodyStyle": "text-align: right",
      "field": "billAmount",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billAmount', $$v)
            },
            expression: "filters['billAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n            " + _vm._s(_vm.totalBillAmount.toFixed(2)) + "\n          ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Counter",
      "bodyStyle": "text-align: right",
      "field": "counterName",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['counterName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'counterName', $$v)
            },
            expression: "filters['counterName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Store",
      "bodyStyle": "text-align: right",
      "field": "warehouseName",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['warehouseName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'warehouseName', $$v)
            },
            expression: "filters['warehouseName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Entered By",
      "bodyStyle": "text-align: right",
      "field": "enteredBy",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['enteredBy']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'enteredBy', $$v)
            },
            expression: "filters['enteredBy']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Updated By",
      "bodyStyle": "text-align: right",
      "field": "updatedBy",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['updatedBy']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'updatedBy', $$v)
            },
            expression: "filters['updatedBy']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action",
      "headerStyle": "width:14em"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.enableDelete) ? _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Delete'),
            expression: "'Delete'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        }) : _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Delete'),
            expression: "'Delete'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "disabled": "",
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        }), _vm._v(" "), _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('View Details'),
            expression: "'View Details'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-warning",
          attrs: {
            "icon": "pi pi-eye"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.viewUnsettleDetail(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Print'),
            expression: "'Print'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised",
          attrs: {
            "icon": "pi pi-print"
          },
          on: {
            "click": function($event) {
              return _vm.printPage(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Print KOT'),
            expression: "'Print KOT'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised",
          attrs: {
            "icon": "pi pi-ticket"
          },
          on: {
            "click": function($event) {
              return _vm.printKOTPage(slotProps.data)
            }
          }
        }), _vm._v(" "), (slotProps.data.deliveryAddress !== '') ? _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Delivery'),
            expression: "'Delivery'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised",
          attrs: {
            "icon": "fa fa-truck"
          },
          on: {
            "click": function($event) {
              return _vm.printDeliveryPage(slotProps.data)
            }
          }
        }) : _vm._e(), _vm._v(" "), (slotProps.data.deliveryAddress !== '') ? _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Exchange'),
            expression: "'Exchange'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-secondary",
          attrs: {
            "icon": "pi pi-refresh"
          },
          on: {
            "click": function($event) {
              return _vm.printExchangePage(slotProps.data)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Edit'),
            expression: "'Edit'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-secondary",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editPosSales(slotProps.data)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-2"
  }, [(this.enableSettle) ? _c('Button', {
    staticClass: "p-button-raised p-button-success",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Settle"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.settleSales()
      }
    }
  }) : _c('Button', {
    staticClass: "p-button-raised p-button-success",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": "",
      "label": "Settle"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.settleSales()
      }
    }
  })], 1)])], 1)]), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteReport
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Cash Sales: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Esewa Sales: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Fonepay Sales: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Khalti Sales : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Ncm Sales : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Bank Sales : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Unpaid Cash: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Unpaid Esewa: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Unpaid Fonepay: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Unpaid Khalti: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Unpaid Ncm: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Unpaid Bank: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Note: Please Settel By Particular Store User Assigned."), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53825cff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/posUnSettleSales.vue
// module id = 2235
// module chunks = 0